import AbsenceReasonModal from './AbsenceReasonModal';

export default AbsenceReasonModal;
